












































import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class DatePicker extends Vue {
  date: string = new Date().toISOString().substr(0, 10);
  menu: boolean = false;

  get dateTime() {
    return this.date;
  }

  @Watch('dateTime', {immediate: true})
  onChangeDateTime() {
    this.$emit('pickDateTime', this.date);
  }

}
